/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthCommunicationsRouteImport } from './routes/_auth/communications'
import { Route as AuthCountriesRouteImport } from './routes/_auth/countries'
import { Route as AuthInterviewQuestionsRouteImport } from './routes/_auth/interview-questions'
import { Route as AuthProfilesRouteRouteImport } from './routes/_auth/profiles/route'
import { Route as AuthReportsRouteRouteImport } from './routes/_auth/reports/route'
import { Route as AuthRequisitionsRouteImport } from './routes/_auth/requisitions'
import { Route as AuthSkillsRouteImport } from './routes/_auth/skills'
import { Route as AuthStatusCodesRouteImport } from './routes/_auth/status-codes'
import { Route as AuthVideosRouteImport } from './routes/_auth/videos'
import { Route as AuthProfilesIndexRouteImport } from './routes/_auth/profiles/index'
import { Route as AuthProfilesApplicantDocumentsRouteImport } from './routes/_auth/profiles/applicant-documents'
import { Route as AuthProfilesListRouteImport } from './routes/_auth/profiles/list'
import { Route as AuthReportsIndexRouteImport } from './routes/_auth/reports/index'
import { Route as AuthReportsAddRouteImport } from './routes/_auth/reports/add'
import { Route as AuthReportsGenerateRouteImport } from './routes/_auth/reports/generate'
import { Route as AuthReportsListRouteImport } from './routes/_auth/reports/list'
import { Route as AuthRequisitionsCreateRouteImport } from './routes/_auth/requisitions/create'
import { Route as AuthSourcesIndexRouteImport } from './routes/_auth/sources/index'
import { Route as AuthSourcesCreateRouteImport } from './routes/_auth/sources/create'
import { Route as AuthSourcesLinksRouteImport } from './routes/_auth/sources/links'
import { Route as AuthStatusCodesIndexRouteImport } from './routes/_auth/status-codes/index'
import { Route as AuthStatusCodesAddRouteImport } from './routes/_auth/status-codes/add'
import { Route as AuthUsersIndexRouteImport } from './routes/_auth/users/index'
import { Route as AuthUsersAddRouteImport } from './routes/_auth/users/add'
import { Route as AuthProfilesBenefitsSearchRouteImport } from './routes/_auth/profiles/benefits.search'
import { Route as AuthSourcesEditSourceIdRouteImport } from './routes/_auth/sources/edit.$sourceId'
import { Route as AuthUsersUserIdEditRouteImport } from './routes/_auth/users/$userId/edit'
import { Route as AuthUsersAdminEditInfoRouteImport } from './routes/_auth/users/admin/edit-info'
import { Route as AuthProfilesBenefitsViewUserIDRouteImport } from './routes/_auth/profiles/benefits.view.$userID'
import { Route as AuthProfilesViewUserIDJobApplicationIDRouteImport } from './routes/_auth/profiles/view.$userID.$jobApplicationID'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCommunicationsRoute = AuthCommunicationsRouteImport.update({
  id: '/communications',
  path: '/communications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCountriesRoute = AuthCountriesRouteImport.update({
  id: '/countries',
  path: '/countries',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInterviewQuestionsRoute = AuthInterviewQuestionsRouteImport.update({
  id: '/interview-questions',
  path: '/interview-questions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfilesRouteRoute = AuthProfilesRouteRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsRouteRoute = AuthReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRequisitionsRoute = AuthRequisitionsRouteImport.update({
  id: '/requisitions',
  path: '/requisitions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSkillsRoute = AuthSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStatusCodesRoute = AuthStatusCodesRouteImport.update({
  id: '/status-codes',
  path: '/status-codes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVideosRoute = AuthVideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfilesIndexRoute = AuthProfilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthProfilesRouteRoute,
} as any)
const AuthProfilesApplicantDocumentsRoute =
  AuthProfilesApplicantDocumentsRouteImport.update({
    id: '/applicant-documents',
    path: '/applicant-documents',
    getParentRoute: () => AuthProfilesRouteRoute,
  } as any)
const AuthProfilesListRoute = AuthProfilesListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AuthProfilesRouteRoute,
} as any)
const AuthReportsIndexRoute = AuthReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthReportsRouteRoute,
} as any)
const AuthReportsAddRoute = AuthReportsAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AuthReportsRouteRoute,
} as any)
const AuthReportsGenerateRoute = AuthReportsGenerateRouteImport.update({
  id: '/generate',
  path: '/generate',
  getParentRoute: () => AuthReportsRouteRoute,
} as any)
const AuthReportsListRoute = AuthReportsListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AuthReportsRouteRoute,
} as any)
const AuthRequisitionsCreateRoute = AuthRequisitionsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthRequisitionsRoute,
} as any)
const AuthSourcesIndexRoute = AuthSourcesIndexRouteImport.update({
  id: '/sources/',
  path: '/sources/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSourcesCreateRoute = AuthSourcesCreateRouteImport.update({
  id: '/sources/create',
  path: '/sources/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSourcesLinksRoute = AuthSourcesLinksRouteImport.update({
  id: '/sources/links',
  path: '/sources/links',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStatusCodesIndexRoute = AuthStatusCodesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthStatusCodesRoute,
} as any)
const AuthStatusCodesAddRoute = AuthStatusCodesAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AuthStatusCodesRoute,
} as any)
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersAddRoute = AuthUsersAddRouteImport.update({
  id: '/users/add',
  path: '/users/add',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfilesBenefitsSearchRoute =
  AuthProfilesBenefitsSearchRouteImport.update({
    id: '/benefits/search',
    path: '/benefits/search',
    getParentRoute: () => AuthProfilesRouteRoute,
  } as any)
const AuthSourcesEditSourceIdRoute = AuthSourcesEditSourceIdRouteImport.update({
  id: '/sources/edit/$sourceId',
  path: '/sources/edit/$sourceId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersUserIdEditRoute = AuthUsersUserIdEditRouteImport.update({
  id: '/users/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersAdminEditInfoRoute = AuthUsersAdminEditInfoRouteImport.update({
  id: '/users/admin/edit-info',
  path: '/users/admin/edit-info',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfilesBenefitsViewUserIDRoute =
  AuthProfilesBenefitsViewUserIDRouteImport.update({
    id: '/benefits/view/$userID',
    path: '/benefits/view/$userID',
    getParentRoute: () => AuthProfilesRouteRoute,
  } as any)
const AuthProfilesViewUserIDJobApplicationIDRoute =
  AuthProfilesViewUserIDJobApplicationIDRouteImport.update({
    id: '/view/$userID/$jobApplicationID',
    path: '/view/$userID/$jobApplicationID',
    getParentRoute: () => AuthProfilesRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/profiles': typeof AuthProfilesRouteRouteWithChildren
  '/reports': typeof AuthReportsRouteRouteWithChildren
  '/communications': typeof AuthCommunicationsRoute
  '/countries': typeof AuthCountriesRoute
  '/interview-questions': typeof AuthInterviewQuestionsRoute
  '/requisitions': typeof AuthRequisitionsRouteWithChildren
  '/skills': typeof AuthSkillsRoute
  '/status-codes': typeof AuthStatusCodesRouteWithChildren
  '/videos': typeof AuthVideosRoute
  '/profiles/applicant-documents': typeof AuthProfilesApplicantDocumentsRoute
  '/profiles/list': typeof AuthProfilesListRoute
  '/reports/add': typeof AuthReportsAddRoute
  '/reports/generate': typeof AuthReportsGenerateRoute
  '/reports/list': typeof AuthReportsListRoute
  '/requisitions/create': typeof AuthRequisitionsCreateRoute
  '/sources/create': typeof AuthSourcesCreateRoute
  '/sources/links': typeof AuthSourcesLinksRoute
  '/status-codes/add': typeof AuthStatusCodesAddRoute
  '/users/add': typeof AuthUsersAddRoute
  '/profiles/': typeof AuthProfilesIndexRoute
  '/reports/': typeof AuthReportsIndexRoute
  '/sources/': typeof AuthSourcesIndexRoute
  '/status-codes/': typeof AuthStatusCodesIndexRoute
  '/users/': typeof AuthUsersIndexRoute
  '/profiles/benefits/search': typeof AuthProfilesBenefitsSearchRoute
  '/sources/edit/$sourceId': typeof AuthSourcesEditSourceIdRoute
  '/users/$userId/edit': typeof AuthUsersUserIdEditRoute
  '/users/admin/edit-info': typeof AuthUsersAdminEditInfoRoute
  '/profiles/benefits/view/$userID': typeof AuthProfilesBenefitsViewUserIDRoute
  '/profiles/view/$userID/$jobApplicationID': typeof AuthProfilesViewUserIDJobApplicationIDRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/communications': typeof AuthCommunicationsRoute
  '/countries': typeof AuthCountriesRoute
  '/interview-questions': typeof AuthInterviewQuestionsRoute
  '/requisitions': typeof AuthRequisitionsRouteWithChildren
  '/skills': typeof AuthSkillsRoute
  '/videos': typeof AuthVideosRoute
  '/': typeof AuthIndexRoute
  '/profiles/applicant-documents': typeof AuthProfilesApplicantDocumentsRoute
  '/profiles/list': typeof AuthProfilesListRoute
  '/reports/add': typeof AuthReportsAddRoute
  '/reports/generate': typeof AuthReportsGenerateRoute
  '/reports/list': typeof AuthReportsListRoute
  '/requisitions/create': typeof AuthRequisitionsCreateRoute
  '/sources/create': typeof AuthSourcesCreateRoute
  '/sources/links': typeof AuthSourcesLinksRoute
  '/status-codes/add': typeof AuthStatusCodesAddRoute
  '/users/add': typeof AuthUsersAddRoute
  '/profiles': typeof AuthProfilesIndexRoute
  '/reports': typeof AuthReportsIndexRoute
  '/sources': typeof AuthSourcesIndexRoute
  '/status-codes': typeof AuthStatusCodesIndexRoute
  '/users': typeof AuthUsersIndexRoute
  '/profiles/benefits/search': typeof AuthProfilesBenefitsSearchRoute
  '/sources/edit/$sourceId': typeof AuthSourcesEditSourceIdRoute
  '/users/$userId/edit': typeof AuthUsersUserIdEditRoute
  '/users/admin/edit-info': typeof AuthUsersAdminEditInfoRoute
  '/profiles/benefits/view/$userID': typeof AuthProfilesBenefitsViewUserIDRoute
  '/profiles/view/$userID/$jobApplicationID': typeof AuthProfilesViewUserIDJobApplicationIDRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/profiles': typeof AuthProfilesRouteRouteWithChildren
  '/_auth/reports': typeof AuthReportsRouteRouteWithChildren
  '/_auth/communications': typeof AuthCommunicationsRoute
  '/_auth/countries': typeof AuthCountriesRoute
  '/_auth/interview-questions': typeof AuthInterviewQuestionsRoute
  '/_auth/requisitions': typeof AuthRequisitionsRouteWithChildren
  '/_auth/skills': typeof AuthSkillsRoute
  '/_auth/status-codes': typeof AuthStatusCodesRouteWithChildren
  '/_auth/videos': typeof AuthVideosRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/profiles/applicant-documents': typeof AuthProfilesApplicantDocumentsRoute
  '/_auth/profiles/list': typeof AuthProfilesListRoute
  '/_auth/reports/add': typeof AuthReportsAddRoute
  '/_auth/reports/generate': typeof AuthReportsGenerateRoute
  '/_auth/reports/list': typeof AuthReportsListRoute
  '/_auth/requisitions/create': typeof AuthRequisitionsCreateRoute
  '/_auth/sources/create': typeof AuthSourcesCreateRoute
  '/_auth/sources/links': typeof AuthSourcesLinksRoute
  '/_auth/status-codes/add': typeof AuthStatusCodesAddRoute
  '/_auth/users/add': typeof AuthUsersAddRoute
  '/_auth/profiles/': typeof AuthProfilesIndexRoute
  '/_auth/reports/': typeof AuthReportsIndexRoute
  '/_auth/sources/': typeof AuthSourcesIndexRoute
  '/_auth/status-codes/': typeof AuthStatusCodesIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
  '/_auth/profiles/benefits/search': typeof AuthProfilesBenefitsSearchRoute
  '/_auth/sources/edit/$sourceId': typeof AuthSourcesEditSourceIdRoute
  '/_auth/users/$userId/edit': typeof AuthUsersUserIdEditRoute
  '/_auth/users/admin/edit-info': typeof AuthUsersAdminEditInfoRoute
  '/_auth/profiles/benefits/view/$userID': typeof AuthProfilesBenefitsViewUserIDRoute
  '/_auth/profiles/view/$userID/$jobApplicationID': typeof AuthProfilesViewUserIDJobApplicationIDRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/profiles'
    | '/reports'
    | '/communications'
    | '/countries'
    | '/interview-questions'
    | '/requisitions'
    | '/skills'
    | '/status-codes'
    | '/videos'
    | '/profiles/applicant-documents'
    | '/profiles/list'
    | '/reports/add'
    | '/reports/generate'
    | '/reports/list'
    | '/requisitions/create'
    | '/sources/create'
    | '/sources/links'
    | '/status-codes/add'
    | '/users/add'
    | '/profiles/'
    | '/reports/'
    | '/sources/'
    | '/status-codes/'
    | '/users/'
    | '/profiles/benefits/search'
    | '/sources/edit/$sourceId'
    | '/users/$userId/edit'
    | '/users/admin/edit-info'
    | '/profiles/benefits/view/$userID'
    | '/profiles/view/$userID/$jobApplicationID'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/communications'
    | '/countries'
    | '/interview-questions'
    | '/requisitions'
    | '/skills'
    | '/videos'
    | '/'
    | '/profiles/applicant-documents'
    | '/profiles/list'
    | '/reports/add'
    | '/reports/generate'
    | '/reports/list'
    | '/requisitions/create'
    | '/sources/create'
    | '/sources/links'
    | '/status-codes/add'
    | '/users/add'
    | '/profiles'
    | '/reports'
    | '/sources'
    | '/status-codes'
    | '/users'
    | '/profiles/benefits/search'
    | '/sources/edit/$sourceId'
    | '/users/$userId/edit'
    | '/users/admin/edit-info'
    | '/profiles/benefits/view/$userID'
    | '/profiles/view/$userID/$jobApplicationID'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/profiles'
    | '/_auth/reports'
    | '/_auth/communications'
    | '/_auth/countries'
    | '/_auth/interview-questions'
    | '/_auth/requisitions'
    | '/_auth/skills'
    | '/_auth/status-codes'
    | '/_auth/videos'
    | '/_auth/'
    | '/_auth/profiles/applicant-documents'
    | '/_auth/profiles/list'
    | '/_auth/reports/add'
    | '/_auth/reports/generate'
    | '/_auth/reports/list'
    | '/_auth/requisitions/create'
    | '/_auth/sources/create'
    | '/_auth/sources/links'
    | '/_auth/status-codes/add'
    | '/_auth/users/add'
    | '/_auth/profiles/'
    | '/_auth/reports/'
    | '/_auth/sources/'
    | '/_auth/status-codes/'
    | '/_auth/users/'
    | '/_auth/profiles/benefits/search'
    | '/_auth/sources/edit/$sourceId'
    | '/_auth/users/$userId/edit'
    | '/_auth/users/admin/edit-info'
    | '/_auth/profiles/benefits/view/$userID'
    | '/_auth/profiles/view/$userID/$jobApplicationID'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/communications': {
      id: '/_auth/communications'
      path: '/communications'
      fullPath: '/communications'
      preLoaderRoute: typeof AuthCommunicationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/countries': {
      id: '/_auth/countries'
      path: '/countries'
      fullPath: '/countries'
      preLoaderRoute: typeof AuthCountriesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/interview-questions': {
      id: '/_auth/interview-questions'
      path: '/interview-questions'
      fullPath: '/interview-questions'
      preLoaderRoute: typeof AuthInterviewQuestionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profiles': {
      id: '/_auth/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof AuthProfilesRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/requisitions': {
      id: '/_auth/requisitions'
      path: '/requisitions'
      fullPath: '/requisitions'
      preLoaderRoute: typeof AuthRequisitionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/skills': {
      id: '/_auth/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthSkillsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/status-codes': {
      id: '/_auth/status-codes'
      path: '/status-codes'
      fullPath: '/status-codes'
      preLoaderRoute: typeof AuthStatusCodesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/videos': {
      id: '/_auth/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof AuthVideosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profiles/': {
      id: '/_auth/profiles/'
      path: '/'
      fullPath: '/profiles/'
      preLoaderRoute: typeof AuthProfilesIndexRouteImport
      parentRoute: typeof AuthProfilesRouteRoute
    }
    '/_auth/profiles/applicant-documents': {
      id: '/_auth/profiles/applicant-documents'
      path: '/applicant-documents'
      fullPath: '/profiles/applicant-documents'
      preLoaderRoute: typeof AuthProfilesApplicantDocumentsRouteImport
      parentRoute: typeof AuthProfilesRouteRoute
    }
    '/_auth/profiles/list': {
      id: '/_auth/profiles/list'
      path: '/list'
      fullPath: '/profiles/list'
      preLoaderRoute: typeof AuthProfilesListRouteImport
      parentRoute: typeof AuthProfilesRouteRoute
    }
    '/_auth/reports/': {
      id: '/_auth/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthReportsIndexRouteImport
      parentRoute: typeof AuthReportsRouteRoute
    }
    '/_auth/reports/add': {
      id: '/_auth/reports/add'
      path: '/add'
      fullPath: '/reports/add'
      preLoaderRoute: typeof AuthReportsAddRouteImport
      parentRoute: typeof AuthReportsRouteRoute
    }
    '/_auth/reports/generate': {
      id: '/_auth/reports/generate'
      path: '/generate'
      fullPath: '/reports/generate'
      preLoaderRoute: typeof AuthReportsGenerateRouteImport
      parentRoute: typeof AuthReportsRouteRoute
    }
    '/_auth/reports/list': {
      id: '/_auth/reports/list'
      path: '/list'
      fullPath: '/reports/list'
      preLoaderRoute: typeof AuthReportsListRouteImport
      parentRoute: typeof AuthReportsRouteRoute
    }
    '/_auth/requisitions/create': {
      id: '/_auth/requisitions/create'
      path: '/create'
      fullPath: '/requisitions/create'
      preLoaderRoute: typeof AuthRequisitionsCreateRouteImport
      parentRoute: typeof AuthRequisitionsRoute
    }
    '/_auth/sources/': {
      id: '/_auth/sources/'
      path: '/sources'
      fullPath: '/sources/'
      preLoaderRoute: typeof AuthSourcesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sources/create': {
      id: '/_auth/sources/create'
      path: '/sources/create'
      fullPath: '/sources/create'
      preLoaderRoute: typeof AuthSourcesCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sources/links': {
      id: '/_auth/sources/links'
      path: '/sources/links'
      fullPath: '/sources/links'
      preLoaderRoute: typeof AuthSourcesLinksRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/status-codes/': {
      id: '/_auth/status-codes/'
      path: '/'
      fullPath: '/status-codes/'
      preLoaderRoute: typeof AuthStatusCodesIndexRouteImport
      parentRoute: typeof AuthStatusCodesRoute
    }
    '/_auth/status-codes/add': {
      id: '/_auth/status-codes/add'
      path: '/add'
      fullPath: '/status-codes/add'
      preLoaderRoute: typeof AuthStatusCodesAddRouteImport
      parentRoute: typeof AuthStatusCodesRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/add': {
      id: '/_auth/users/add'
      path: '/users/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof AuthUsersAddRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profiles/benefits/search': {
      id: '/_auth/profiles/benefits/search'
      path: '/benefits/search'
      fullPath: '/profiles/benefits/search'
      preLoaderRoute: typeof AuthProfilesBenefitsSearchRouteImport
      parentRoute: typeof AuthProfilesRouteRoute
    }
    '/_auth/sources/edit/$sourceId': {
      id: '/_auth/sources/edit/$sourceId'
      path: '/sources/edit/$sourceId'
      fullPath: '/sources/edit/$sourceId'
      preLoaderRoute: typeof AuthSourcesEditSourceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/$userId/edit': {
      id: '/_auth/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AuthUsersUserIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/admin/edit-info': {
      id: '/_auth/users/admin/edit-info'
      path: '/users/admin/edit-info'
      fullPath: '/users/admin/edit-info'
      preLoaderRoute: typeof AuthUsersAdminEditInfoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profiles/benefits/view/$userID': {
      id: '/_auth/profiles/benefits/view/$userID'
      path: '/benefits/view/$userID'
      fullPath: '/profiles/benefits/view/$userID'
      preLoaderRoute: typeof AuthProfilesBenefitsViewUserIDRouteImport
      parentRoute: typeof AuthProfilesRouteRoute
    }
    '/_auth/profiles/view/$userID/$jobApplicationID': {
      id: '/_auth/profiles/view/$userID/$jobApplicationID'
      path: '/view/$userID/$jobApplicationID'
      fullPath: '/profiles/view/$userID/$jobApplicationID'
      preLoaderRoute: typeof AuthProfilesViewUserIDJobApplicationIDRouteImport
      parentRoute: typeof AuthProfilesRouteRoute
    }
  }
}

interface AuthProfilesRouteRouteChildren {
  AuthProfilesApplicantDocumentsRoute: typeof AuthProfilesApplicantDocumentsRoute
  AuthProfilesListRoute: typeof AuthProfilesListRoute
  AuthProfilesIndexRoute: typeof AuthProfilesIndexRoute
  AuthProfilesBenefitsSearchRoute: typeof AuthProfilesBenefitsSearchRoute
  AuthProfilesBenefitsViewUserIDRoute: typeof AuthProfilesBenefitsViewUserIDRoute
  AuthProfilesViewUserIDJobApplicationIDRoute: typeof AuthProfilesViewUserIDJobApplicationIDRoute
}

const AuthProfilesRouteRouteChildren: AuthProfilesRouteRouteChildren = {
  AuthProfilesApplicantDocumentsRoute: AuthProfilesApplicantDocumentsRoute,
  AuthProfilesListRoute: AuthProfilesListRoute,
  AuthProfilesIndexRoute: AuthProfilesIndexRoute,
  AuthProfilesBenefitsSearchRoute: AuthProfilesBenefitsSearchRoute,
  AuthProfilesBenefitsViewUserIDRoute: AuthProfilesBenefitsViewUserIDRoute,
  AuthProfilesViewUserIDJobApplicationIDRoute:
    AuthProfilesViewUserIDJobApplicationIDRoute,
}

const AuthProfilesRouteRouteWithChildren =
  AuthProfilesRouteRoute._addFileChildren(AuthProfilesRouteRouteChildren)

interface AuthReportsRouteRouteChildren {
  AuthReportsAddRoute: typeof AuthReportsAddRoute
  AuthReportsGenerateRoute: typeof AuthReportsGenerateRoute
  AuthReportsListRoute: typeof AuthReportsListRoute
  AuthReportsIndexRoute: typeof AuthReportsIndexRoute
}

const AuthReportsRouteRouteChildren: AuthReportsRouteRouteChildren = {
  AuthReportsAddRoute: AuthReportsAddRoute,
  AuthReportsGenerateRoute: AuthReportsGenerateRoute,
  AuthReportsListRoute: AuthReportsListRoute,
  AuthReportsIndexRoute: AuthReportsIndexRoute,
}

const AuthReportsRouteRouteWithChildren =
  AuthReportsRouteRoute._addFileChildren(AuthReportsRouteRouteChildren)

interface AuthRequisitionsRouteChildren {
  AuthRequisitionsCreateRoute: typeof AuthRequisitionsCreateRoute
}

const AuthRequisitionsRouteChildren: AuthRequisitionsRouteChildren = {
  AuthRequisitionsCreateRoute: AuthRequisitionsCreateRoute,
}

const AuthRequisitionsRouteWithChildren =
  AuthRequisitionsRoute._addFileChildren(AuthRequisitionsRouteChildren)

interface AuthStatusCodesRouteChildren {
  AuthStatusCodesAddRoute: typeof AuthStatusCodesAddRoute
  AuthStatusCodesIndexRoute: typeof AuthStatusCodesIndexRoute
}

const AuthStatusCodesRouteChildren: AuthStatusCodesRouteChildren = {
  AuthStatusCodesAddRoute: AuthStatusCodesAddRoute,
  AuthStatusCodesIndexRoute: AuthStatusCodesIndexRoute,
}

const AuthStatusCodesRouteWithChildren = AuthStatusCodesRoute._addFileChildren(
  AuthStatusCodesRouteChildren,
)

interface AuthRouteChildren {
  AuthProfilesRouteRoute: typeof AuthProfilesRouteRouteWithChildren
  AuthReportsRouteRoute: typeof AuthReportsRouteRouteWithChildren
  AuthCommunicationsRoute: typeof AuthCommunicationsRoute
  AuthCountriesRoute: typeof AuthCountriesRoute
  AuthInterviewQuestionsRoute: typeof AuthInterviewQuestionsRoute
  AuthRequisitionsRoute: typeof AuthRequisitionsRouteWithChildren
  AuthSkillsRoute: typeof AuthSkillsRoute
  AuthStatusCodesRoute: typeof AuthStatusCodesRouteWithChildren
  AuthVideosRoute: typeof AuthVideosRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthSourcesCreateRoute: typeof AuthSourcesCreateRoute
  AuthSourcesLinksRoute: typeof AuthSourcesLinksRoute
  AuthUsersAddRoute: typeof AuthUsersAddRoute
  AuthSourcesIndexRoute: typeof AuthSourcesIndexRoute
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
  AuthSourcesEditSourceIdRoute: typeof AuthSourcesEditSourceIdRoute
  AuthUsersUserIdEditRoute: typeof AuthUsersUserIdEditRoute
  AuthUsersAdminEditInfoRoute: typeof AuthUsersAdminEditInfoRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthProfilesRouteRoute: AuthProfilesRouteRouteWithChildren,
  AuthReportsRouteRoute: AuthReportsRouteRouteWithChildren,
  AuthCommunicationsRoute: AuthCommunicationsRoute,
  AuthCountriesRoute: AuthCountriesRoute,
  AuthInterviewQuestionsRoute: AuthInterviewQuestionsRoute,
  AuthRequisitionsRoute: AuthRequisitionsRouteWithChildren,
  AuthSkillsRoute: AuthSkillsRoute,
  AuthStatusCodesRoute: AuthStatusCodesRouteWithChildren,
  AuthVideosRoute: AuthVideosRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthSourcesCreateRoute: AuthSourcesCreateRoute,
  AuthSourcesLinksRoute: AuthSourcesLinksRoute,
  AuthUsersAddRoute: AuthUsersAddRoute,
  AuthSourcesIndexRoute: AuthSourcesIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
  AuthSourcesEditSourceIdRoute: AuthSourcesEditSourceIdRoute,
  AuthUsersUserIdEditRoute: AuthUsersUserIdEditRoute,
  AuthUsersAdminEditInfoRoute: AuthUsersAdminEditInfoRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
